import IconDiscussion from '../../../../images/icons/discussion.svg';
import IconFaceWink from '../../../../images/icons/face-wink.svg';
import IconNotification from '../../../../images/icons/notification.svg';
import IconTicket from '../../../../images/icons/ticket.svg';

export interface IBullet {
  src: string;
  message: string;
  altMessage: string;
}

export const APP_BULLETS: IBullet[] = [
  {
    src: IconTicket,
    message: 'appBulletTicket',
    altMessage: 'Ticket icon',
  },
  {
    src: IconFaceWink,
    message: 'appBulletNoAds',
    altMessage: 'Face Wink icon',
  },
  {
    src: IconDiscussion,
    message: 'appBulletCustomerService',
    altMessage: 'Discussion icon',
  },
  {
    src: IconNotification,
    message: 'appBulletNotification',
    altMessage: 'Notification icon',
  },
];
